import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { SectionTemplate } from '../../components';
import mask from '../../images/blob-shape-2.svg';
import { media } from '../../utils/mixins';

export const Last = () => {
    const { bar } = useStaticQuery(query);
    return (
        <SectionTemplate
            headingText="Sharable Points"
            paragraphText={`A controlled way to ensure points are being sent to new
                users and customer reach is maximized`}
            imageContent={<Image fluid={bar.childImageSharp.fluid} />}
        />
    );
};

const query = graphql`
    {
        bar: file(relativePath: { eq: "bar.jpg" }) {
            childImageSharp {
                fluid(maxWidth: 800, quality: 90) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`;

const Image = styled(Img)`
    mask: url(${mask});
    mask-size: cover;
    max-width: 26rem;
    max-height: 26rem;
    width: 100%;
    height: auto;
    ${media.tablet`
        max-width: 20rem;
        max-height: 20rem;
    `}
`;
